export function deepCopy(object: any): any {
  let copiedObject: any, value: any, key: any;

  if (typeof object !== 'object' || object === null) {
    return object; // return the value if object is not an object (primitive)
  }

  // Create an array or object to hold the values
  copiedObject = Array.isArray(object) ? [] : {};

  for (key in object) {
    value = object[key];

    // Recursively (deep) copy for nested objects, including arrays
    copiedObject[key] = deepCopy(value);
  }

  return copiedObject;
}
